import { tKeys } from 'locales';
import { isEmpty } from 'remeda';
import type { ActionButtonDefinition, ActionButtonType } from './action-button-definition';

export type ActionButtonGroup = {
  translationKey: string;
  definitions: Array<ActionButtonDefinition>;
};

const ACTION_BUTTON_GROUP_MEMBERS: ReadonlyArray<{
  translationKey: string;
  types: ReadonlyArray<ActionButtonType>;
}> = [
  {
    translationKey: tKeys.MODULES.AT_RISK.ACTION_GROUPS.CASE_STATUS,
    types: ['mark_as_paid', 'mark_as_unrecoverable', 'mark_as_disputed', 'pause'],
  },
  {
    translationKey: tKeys.MODULES.AT_RISK.ACTION_GROUPS.DUNNING,
    types: ['payment_plan', 'additional_reminder', 'formal_notice', 'direct_contact'],
  },
  {
    translationKey: tKeys.MODULES.AT_RISK.ACTION_GROUPS.THIRD_PARTIES,
    types: ['lawyer', 'bailiff', 'debt_collection'],
  },
];

export type TypedActionButton = {
  type: ActionButtonType;
  definition: ActionButtonDefinition;
};

export function groupActionButtons(
  buttons: ReadonlyArray<TypedActionButton>,
): Array<ActionButtonGroup> {
  return ACTION_BUTTON_GROUP_MEMBERS.map(group => ({
    translationKey: group.translationKey,
    definitions: group.types.flatMap(type =>
      buttons.filter(button => button.type === type).map(button => button.definition),
    ),
  })).filter(group => !isEmpty(group.definitions));
}
